import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PriceTypes, PriceTypeService } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import { concatMap, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { PriceTypeChangedApplicationEvent } from '~shared/modules/application-event/models';
import {
  PRICE_TYPE_LOCATION_TOGGLER
} from '~shared/modules/price-type-toggler/constants/interaction-location.constant';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';

@Component({
  selector: 'app-price-switch',
  templateUrl: './price-switch.component.html',
  styleUrls: ['./price-switch.component.scss']
})
export class PriceSwitchComponent implements OnInit, OnDestroy {
  @Input() inCategoriesMenu = false;
  @Input() mobileMenuShown: boolean;
  @Input() mobileSidenavMenu = false;
  @Input() inputId: string;

  priceType$ = new BehaviorSubject<PriceTypes>(PriceTypes.b2b);
  isTogglerActive: boolean;
  destroySubject$ = new Subject();
  b2b = PriceTypes.b2b;
  b2c = PriceTypes.b2c;
  public PendingState = AuthorizationStateType.Pending;

  authState$ = this.authIdamStateService.state$;


  constructor(
    private priceTypeSvc: PriceTypeService,
    private applicationEventService: ApplicationEventService,
    private authIdamStateService: AuthorizationIdamStateService,
  ) {}

  ngOnInit(): void {
    this.priceTypeSvc.priceType$
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(
        (priceType: PriceTypes) =>  this.priceType$.next(priceType)
      );


    this.priceTypeSvc.isTogglerActive$.pipe(takeUntil(this.destroySubject$))
    .subscribe((isActive: boolean) => this.isTogglerActive = isActive);
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  public setPrice(priceType: PriceTypes) {
    this.priceTypeSvc.setPriceType(priceType);
    this.trackPriceTypeChange(priceType);
  }

  public onChange($event: any): void {
    const priceType = !$event.target.checked ? this.b2c : this.b2b;
    this.priceTypeSvc.setPriceType(priceType);
    this.trackPriceTypeChange(priceType);
  }

  private trackPriceTypeChange(priceType) {
    this.applicationEventService.publish(
      new PriceTypeChangedApplicationEvent(
        priceType,
        PRICE_TYPE_LOCATION_TOGGLER
      )
    );
  }

}
